export const LOADER_STATUS = 'boilderplate/ITC04/Return/LOADER_STATUS';
export const FILE_DATA = "boilderplate/ITC04/Return/FILE_DATA";
export const SET_FREQUENCY = "boilderplate/ITC04/Return/SET_FREQUENCY";